<template>
  <div>
    <div id="app">
      <appcomponent></appcomponent>
      <navbar-top @logout="logout()" id="navbar" :class="{ collapse: isCollapsed }"></navbar-top>
      <transition name="fade" mode="out-in">
        <RouterView :key="currentRoute" />
      </transition>
      <Footer v-if="footerShow"></Footer>
    </div>
    <darkmodecomponent v-if="readyStateComplete"></darkmodecomponent>
    <cookie-law v-if="readyStateComplete">
      <div slot-scope="props" style="width: 100%">
        Ikleeralles.nl maakt gebruik van Cookies.
        <router-link to="/pp.pdf" target="_blank">Meer informatie</router-link>
        <b-button class="is-pulled-right" type="is-success" @click="props.accept">Begrepen</b-button>
      </div>
    </cookie-law>
  </div>
</template>

<script>
import { EventBus } from "./common/event-bus"
import NavbarTop from "./components/NavbarTop.vue"
import { USER_LOGOUT } from "./store/User/action.type"
import { APP_INIT } from "./store/App/action.type"
import CookieLaw from "vue-cookie-law"
import Footer from "./components/Footer.vue"

export default {
  components: {
    "cookie-law": CookieLaw,
    NavbarTop,
    Footer,
  },
  data() {
    return {
      readyStateComplete: false,
    }
  },
  mounted() {
    document.onreadystatechange = () => {
      if (document.readyState == "complete") this.readyStateComplete = true
    }

    this.init()
    this.setPremiumModalListener()
  },
  methods: {
    setPremiumModalListener() {
      EventBus.$on("showPremium", () => {
        return this.$buefy.dialog.confirm({
          title: "Premium optie",
          message: "Voor deze optie heb je premium nodig. Je kunt al premium aanschaffen vanaf €1,99/maand.",
          hasIcon: true,
          icon: "exclamation-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true,
          cancelText: "Sluiten",
          confirmText: "Bekijken",
          onConfirm: () => this.$router.push("/premium"),
        })
      })
    },
    async init() {
      await this.$store.dispatch(APP_INIT)
      this.isLoading = false

      let refferal = this.$route.query.r
      if (typeof refferal !== "undefined") {
        $cookies.set("refferal", refferal)
      }
    },
    async logout() {
      await this.$store.dispatch(USER_LOGOUT)
      window.location.href = "/"
      this.$buefy.toast.open({
        message: "Je bent succesvol uitgelogd",
        type: "is-success",
      })
    },
  },
  computed: {
    isCollapsed() {
      return this.$route.meta.hideNavbar
    },
    onDashboard() {
      return this.$route.path === "/dashboard"
    },
    loggedIn() {
      return this.$store.state["user"].loggedIn
    },
    footerShow() {
      return this.$route.meta.showFooter
    },
    currentRoute() {
      return this.$route.fullPath
    },
  },
}
</script>
<style lang="scss" scoped>
#app {
  display: flex;
  flex-flow: column;
  overflow-x: hidden;
}
.blue {
  background-color: #1c73f4;
  &:has(.is-active) {
    background-color: transparent;
  }
}
</style>
